import React, { useState, useEffect, useRef } from 'react';

// Central API Router Path for Standalone Version
const API_BASE = './api/router.php?route=';

const FcomifyStandalone = () => {
    // Top Navigation State
    const [activeTab, setActiveTab] = useState('chat'); 
    const [isAppLoading, setIsAppLoading] = useState(true); 
    
    // Core Data States
    const [groups, setGroups] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [logs, setLogs] = useState([]);

    // 1. Settings & License State
    const [testStatus, setTestStatus] = useState(null);
    const [isTesting, setIsTesting] = useState(false);
    const [licenseKey, setLicenseKey] = useState(''); 
    const [hasLicense, setHasLicense] = useState(false); 
    
    // API Settings State
    const [metaToken, setMetaToken] = useState('');
    const [phoneId, setPhoneId] = useState('');
    const [businessId, setBusinessId] = useState('');
    const [webhookToken, setWebhookToken] = useState('fcomify_secure_123');
    const [notifyEnable, setNotifyEnable] = useState('0');
    const [notifyEmail, setNotifyEmail] = useState('');
    
    // 2. Chat State
    const [selectedPhone, setSelectedPhone] = useState(null);
    const [chatReply, setChatReply] = useState('');
    const [chatMediaUrl, setChatMediaUrl] = useState(''); 
    const [showUnreadOnly, setShowUnreadOnly] = useState(false);
    const [chatSearchQuery, setChatSearchQuery] = useState('');
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    // 3. Phonebook / Import State
    const [newGroupName, setNewGroupName] = useState('');
    const [importGroupId, setImportGroupId] = useState('');
    const [parsedContacts, setParsedContacts] = useState([]);
    const [importStatus, setImportStatus] = useState('');

    // 4. Campaign / Schedule State
    const [campaignTargetType, setCampaignTargetType] = useState('group');
    const [campaignGroup, setCampaignGroup] = useState('');
    const [campaignManualNumbers, setCampaignManualNumbers] = useState('');
    const [campaignTemplate, setCampaignTemplate] = useState('');
    const [campaignMessage, setCampaignMessage] = useState('');
    const [campaignMediaUrl, setCampaignMediaUrl] = useState(''); 
    const [campaignScheduleTime, setCampaignScheduleTime] = useState(''); 
    const [campaignStatus, setCampaignStatus] = useState(null);
    const [isSending, setIsSending] = useState(false);
    
    // 5. Template Builder State
    const [showBuilder, setShowBuilder] = useState(false);
    const [isSyncing, setIsSyncing] = useState(false);
    const [syncStatus, setSyncStatus] = useState('');
    const [templateSearchQuery, setTemplateSearchQuery] = useState(''); 
    const [tplName, setTplName] = useState('');
    const [tplCategory, setTplCategory] = useState('MARKETING');
    const [tplLanguage, setTplLanguage] = useState('en_US');
    const [tplHeaderType, setTplHeaderType] = useState('NONE');
    const [tplHeaderText, setTplHeaderText] = useState('');
    const [tplHeaderMediaUrl, setTplHeaderMediaUrl] = useState(''); 
    const [tplBody, setTplBody] = useState('');
    const [tplFooter, setTplFooter] = useState('');
    const [tplButtons, setTplButtons] = useState([]);
    const [tplSubmitStatus, setTplSubmitStatus] = useState(null);

    // 6. Lead Management State
    const [leads, setLeads] = useState([]);
    const [leadFilter, setLeadFilter] = useState('all');
    const [isFetchingLeads, setIsFetchingLeads] = useState(false);

    // 7. FAQ & Support State
    const [faqSearchQuery, setFaqSearchQuery] = useState('');
    const [supportTickets, setSupportTickets] = useState([]);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [showTicketForm, setShowTicketForm] = useState(false);
    const [supportSubject, setSupportSubject] = useState('');
    const [supportMessage, setSupportMessage] = useState('');
    const [supportStatus, setSupportStatus] = useState(null);
    const [ticketReply, setTicketReply] = useState('');
    const [isReplying, setIsReplying] = useState(false);

    const faqList = [
        { question: "Can I use custom variables like {{customer_name}} in templates?", answer: "Yes! Use our Template Builder. You can type {{customer_name}} or {{order_id}}, and our Smart Variable Converter will automatically format it for Meta's strict API so you never get a rejection error." },
        { question: "How do I schedule a bulk campaign?", answer: "In the 'Schedule Message' tab, select your target group or numbers, write your message, and pick a Date & Time. The system will hold the message and send it within 5 minutes of your scheduled time." },
        { question: "What is Intelligent Lead Management?", answer: "The CRM automatically cross-references your phonebook and chat logs. It calculates exactly how many days it has been since you last messaged a customer, allowing you to filter 'cold' leads and add them to a target group." },
        { question: "Why is my message stuck with an 'Invalid parameter' error in the logs?", answer: "Meta is very strict. If a template expects an image, you MUST attach an image URL. If it expects 2 variables, you must provide them. Use the Template Builder to avoid these errors." }
    ];

    const commonEmojis = [
        '😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠',
        '👍','👎','👌','✌️','🤞','🫰','🤟','🤘','🤙','👈','👉','👆','👇','☝️','✋','🤚','🖐','🖖','👋','🤙','💪','🖕','✍️','🙏','🫵','🦶','🦵','🦿','💄','💋','👄','🦷','👅','👂','🦻','👃','👣','👁','👀','🧠','🫀','🫁','💀','👽','👀','❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','❤️‍🩹','❣️','💕','💞','💓','💗','💖','💘','💝','✅','❌','💯','✨','🔥','🎉'
    ];

    const fetchLogs = async () => {
        try {
            const res = await fetch(`${API_BASE}logs`);
            const data = await res.json();
            if (data.success) setLogs(data.data);
        } catch (e) { console.error("Logs fetch failed"); }
    };

    useEffect(() => {
        const loadAllData = async () => {
            await fetchSettings();
            fetchGroups();
            fetchTemplates();
            fetchLogs();
            if (activeTab === 'phonebook') fetchContacts();
            if (activeTab === 'leads') fetchLeads();
            if (activeTab === 'support') fetchSupportTickets();
            setIsAppLoading(false); 
        };
        loadAllData();

        // LIVE POLLING ENGINE (Every 3 seconds)
        const logPoller = setInterval(() => { fetchLogs(); }, 3000);
        return () => clearInterval(logPoller);
    }, [activeTab, leadFilter]);

    const fetchGroups = async () => {
        const res = await fetch(`${API_BASE}groups`);
        if (res.ok) setGroups(await res.json());
    };
    const fetchContacts = async () => {
        const res = await fetch(`${API_BASE}contacts`);
        if (res.ok) setContacts(await res.json());
    };
    const fetchTemplates = async () => {
        const res = await fetch(`${API_BASE}templates`);
        const data = await res.json();
        if (data.success) setTemplates(data.data);
    };
    const fetchLeads = async () => {
        setIsFetchingLeads(true);
        const res = await fetch(`${API_BASE}leads&filter=${leadFilter}`);
        if (res.ok) setLeads(await res.json());
        setIsFetchingLeads(false);
    };
    const fetchSupportTickets = async () => {
        const res = await fetch(`${API_BASE}support`);
        const data = await res.json();
        if (data.success) setSupportTickets(data.data);
    };
    
    const fetchSettings = async () => {
        try {
            const res = await fetch(`${API_BASE}settings&time=${Date.now()}`, { cache: 'no-store' });
            const data = await res.json();
            
            if (data.license_key) { setLicenseKey(data.license_key); setHasLicense(true); } 
            else { setHasLicense(false); if (activeTab !== 'settings') setActiveTab('settings'); }

            setMetaToken(data.meta_token || '');
            setPhoneId(data.phone_id || '');
            setBusinessId(data.business_id || '');
            setWebhookToken(data.webhook_token || 'fcomify_secure_123');
            setNotifyEnable(data.notify_enable || '0');
            setNotifyEmail(data.notify_email || '');
        } catch (e) {
            console.error("Settings fetch failed");
        }
    };

    // STANDALONE FILE HANDLER: Replaces WordPress Media Library
    const handleMediaPrompt = (setterFunction) => {
        const url = prompt("Enter the direct URL of the media file (e.g. https://yourdomain.com/image.jpg):");
        if (url && url.trim() !== "") {
            setterFunction(url.trim());
        }
    };

    const handleTestConnection = async () => {
        setIsTesting(true); setTestStatus(null);
        try {
            const response = await fetch(`${API_BASE}test-connection`);
            const data = await response.json();
            setTestStatus({ type: response.ok ? 'success' : 'error', text: data.message });
        } catch (error) { setTestStatus({ type: 'error', text: 'Network connection failed.' }); } 
        finally { setIsTesting(false); }
    };
    
    const handleSaveSettings = async () => {
        const payload = { 
            license_key: licenseKey,
            meta_token: metaToken,
            phone_id: phoneId,
            business_id: businessId,
            webhook_token: webhookToken,
            notify_enable: notifyEnable,
            notify_email: notifyEmail
        };

        await fetch(`${API_BASE}settings`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify(payload) 
        });
        setHasLicense(!!licenseKey);
        alert('Settings Saved Successfully!');
    };

    const handleSelectChat = async (phone) => {
        setSelectedPhone(phone);
        await fetch(`${API_BASE}logs-read`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ phone }) 
        });
        fetchLogs();
    };
    
    const handleSendReply = async (e) => {
        e.preventDefault();
        if ((!chatReply && !chatMediaUrl) || !selectedPhone) return;
        const logText = chatMediaUrl ? `[Media: ${chatMediaUrl}] ${chatReply}` : chatReply;
        const tempMsg = { id: Date.now(), phone_number: selectedPhone, message_body: logText, direction: 'outbound', timestamp: new Date().toISOString() };
        
        setLogs(prev => [...prev, tempMsg]); 
        const payload = { phone: selectedPhone, message: chatReply, media_url: chatMediaUrl };
        setChatReply(''); setChatMediaUrl(''); setShowEmojiPicker(false);
        
        await fetch(`${API_BASE}send`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify(payload) 
        });
        fetchLogs();
    };

    const handleSendOrScheduleCampaign = async (e) => {
        e.preventDefault(); setIsSending(true); setCampaignStatus(null);
        const payload = { 
            target_type: campaignTargetType, 
            template_name: campaignTemplate, 
            message: campaignMessage, 
            media_url: campaignMediaUrl,
            schedule_time: campaignScheduleTime 
        };
        if (campaignTargetType === 'group') payload.group_id = campaignGroup;
        else payload.manual_numbers = campaignManualNumbers;

        const res = await fetch(`${API_BASE}campaigns-send`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify(payload) 
        });
        const data = await res.json();
        setIsSending(false);
        if (data.success) { 
            if (data.scheduled) {
                setCampaignStatus({ type: 'success', text: `✅ ${data.message}` });
            } else {
                setCampaignStatus({ type: 'success', text: `✅ Blast finished! Sent: ${data.sent}, Failed: ${data.failed}` }); 
            }
            setCampaignManualNumbers(''); setCampaignScheduleTime(''); fetchLogs(); 
        }
        else { setCampaignStatus({ type: 'error', text: data.message || 'Campaign failed.' }); }
    };

    const handleAddGroup = async (e) => {
        e.preventDefault();
        const res = await fetch(`${API_BASE}groups`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ group_name: newGroupName }) 
        });
        if (res.ok) { setNewGroupName(''); fetchGroups(); }
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            const lines = text.split('\n');
            const contactsList = [];
            lines.forEach(line => {
                const parts = line.split(',');
                if (parts.length >= 2) {
                    const name = parts[0].trim();
                    const rawPhone = parts[1].replace(/[^0-9]/g, '');
                    if (name && rawPhone) contactsList.push({ name, phone: rawPhone });
                } else if (parts.length === 1 && parts[0].replace(/[^0-9]/g, '').length > 7) {
                    contactsList.push({ name: 'Imported Contact', phone: parts[0].replace(/[^0-9]/g, '') });
                }
            });
            setParsedContacts(contactsList);
            setImportStatus(`Loaded ${contactsList.length} valid contacts from file.`);
        };
        reader.readAsText(file);
    };

    const handleBulkImport = async () => {
        if (parsedContacts.length === 0 || !importGroupId) { alert('Select a file and a destination group first.'); return; }
        setImportStatus('Importing contacts... please wait.');
        try {
            const res = await fetch(`${API_BASE}contacts-bulk`, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify({ group_id: importGroupId, contacts: parsedContacts }) 
            });
            const data = await res.json();
            if (data.success) { setImportStatus(`✅ Successfully imported ${data.imported} contacts!`); setParsedContacts([]); fetchContacts(); } 
            else { setImportStatus(`❌ Import failed: ${data.message}`); }
        } catch (err) { setImportStatus('❌ Network error during import.'); }
    };

    const handleCreateGroupFromLeads = async () => {
        const groupName = prompt(`Enter a group name for these ${leads.length} leads:`);
        if (!groupName) return;
        const phones = leads.map(l => l.phone);
        const res = await fetch(`${API_BASE}leads-group`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ group_name: groupName, phones: phones }) 
        });
        const data = await res.json();
        if (data.success) { alert(`Group "${groupName}" created with ${data.imported} contacts!`); fetchGroups(); }
    };

    const handleSyncTemplates = async () => {
        setIsSyncing(true); setSyncStatus('Connecting to Meta...');
        try {
            const res = await fetch(`${API_BASE}templates-sync`, { method: 'POST' });
            const data = await res.json();
            if (data.success) { setSyncStatus(`Successfully synced ${data.synced} approved templates!`); fetchTemplates(); } 
            else { setSyncStatus(`Error: ${data.message}`); }
        } catch (err) { setSyncStatus('Network error.'); } 
        finally { setIsSyncing(false); }
    };

    const handleCreateTemplate = async (e) => {
        e.preventDefault();
        setTplSubmitStatus('Submitting to Meta for approval...');
        const components = [];
        
        if (tplHeaderType === 'TEXT') {
            components.push({ type: 'HEADER', format: 'TEXT', text: tplHeaderText });
        } else if (tplHeaderType === 'IMAGE') {
            components.push({ type: 'HEADER', format: 'IMAGE', example: { header_handle: [tplHeaderMediaUrl || "https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"] } });
        } else if (tplHeaderType === 'VIDEO') {
            components.push({ type: 'HEADER', format: 'VIDEO', example: { header_handle: [tplHeaderMediaUrl] } });
        }
        
        let formattedBody = tplBody;
        let maxVar = 0;
        const allMatches = tplBody.match(/\{\{(.*?)\}\}/g);
        
        if (allMatches) {
            const hasNamed = allMatches.some(m => !m.match(/\{\{(\d+)\}\}/));
            if (hasNamed) {
                const uniqueTags = [...new Set(allMatches)];
                maxVar = uniqueTags.length;
                uniqueTags.forEach((tag, index) => { formattedBody = formattedBody.split(tag).join(`{{${index + 1}}}`); });
            } else {
                allMatches.forEach(m => { const num = parseInt(m.replace(/[^0-9]/g, ''), 10); if (num > maxVar) maxVar = num; });
            }
        }

        const bodyComp = { type: 'BODY', text: formattedBody };

        if (maxVar > 0) {
            const examples = [];
            for (let i = 1; i <= maxVar; i++) { examples.push(`SampleData${i}`); }
            bodyComp.example = { body_text: [examples] };
        }
        components.push(bodyComp);

        if (tplFooter) components.push({ type: 'FOOTER', text: tplFooter });
        if (tplButtons.length > 0) components.push({ type: 'BUTTONS', buttons: tplButtons.map(b => ({ type: 'QUICK_REPLY', text: b.text })) });

        const payload = { 
            name: tplName.toLowerCase().replace(/[^a-z0-9_]/g, '_'), 
            category: tplCategory, 
            language: tplLanguage, 
            components: components 
        };

        try {
            const res = await fetch(`${API_BASE}templates-create`, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify(payload) 
            });
            const data = await res.json();
            if (data.success) {
                setTplSubmitStatus('✅ Template successfully submitted! Status: PENDING. Sync in a few minutes.');
                setTimeout(() => setShowBuilder(false), 3000);
            } else {
                setTplSubmitStatus(`❌ Meta Error: ${data.message || 'Invalid format'}`);
            }
        } catch (err) { setTplSubmitStatus('❌ Network Error during submission.'); }
    };

    const handleSendSupportTicket = async (e) => {
        e.preventDefault();
        setSupportStatus({ type: 'loading', text: 'Creating ticket & sending email securely...' });
        
        try {
            const res = await fetch(`${API_BASE}support`, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify({ subject: supportSubject, message: supportMessage }) 
            });
            const data = await res.json();
            if (data.success) {
                setSupportStatus({ type: 'success', text: data.message });
                setSupportSubject(''); setSupportMessage('');
                fetchSupportTickets();
                setTimeout(() => { setShowTicketForm(false); setSupportStatus(null); }, 2000);
            } else {
                setSupportStatus({ type: 'error', text: data.message });
            }
        } catch (err) { setSupportStatus({ type: 'error', text: 'Network connection failed.' }); }
    };

    const handleSendTicketReply = async (e) => {
        e.preventDefault();
        if (!ticketReply || !selectedTicket) return;
        setIsReplying(true);
        
        try {
            const res = await fetch(`${API_BASE}support-reply`, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify({ ticket_id: selectedTicket.id, message: ticketReply }) 
            });
            const data = await res.json();
            if (data.success) {
                setTicketReply('');
                fetchSupportTickets();
                
                const updatedHistory = JSON.parse(selectedTicket.chat_history);
                updatedHistory.push({ sender: 'You', message: ticketReply, timestamp: new Date().toISOString() });
                setSelectedTicket({...selectedTicket, chat_history: JSON.stringify(updatedHistory)});
            }
        } catch (err) { alert('Failed to send reply'); }
        setIsReplying(false);
    };

    const formatTime = (dateString) => new Date(dateString).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    
    const renderChatBubbleContent = (body) => {
        if (body.startsWith('[Media: ')) {
            const parts = body.split('] ');
            const mediaUrl = parts[0].replace('[Media: ', '');
            const text = parts.slice(1).join('] ');
            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <a href={mediaUrl} target="_blank" rel="noreferrer" style={{ fontSize: '11px', background: 'rgba(0,0,0,0.1)', padding: '6px', borderRadius: '4px', marginBottom: text ? '6px' : '0', color: 'inherit', textDecoration: 'none', display: 'block', wordBreak: 'break-all' }}>📎 Attachment View</a>
                    {text && <span>{text}</span>}
                </div>
            );
        }
        return body;
    };

    const chatSidebar = [];
    const groupedLogs = {};
    logs.forEach(log => {
        if (!groupedLogs[log.phone_number]) groupedLogs[log.phone_number] = [];
        groupedLogs[log.phone_number].push(log);
    });
    Object.keys(groupedLogs).forEach(phone => {
        const messages = groupedLogs[phone];
        const lastMsg = messages[messages.length - 1];
        const unreadCount = messages.filter(m => String(m.is_read) === "0" && m.direction === 'inbound').length;
        chatSidebar.push({ phone, lastMsg, unreadCount });
    });
    chatSidebar.sort((a, b) => new Date(b.lastMsg.timestamp) - new Date(a.lastMsg.timestamp));
    
    let displaySidebar = chatSidebar;
    if (showUnreadOnly) {
        displaySidebar = displaySidebar.filter(c => c.unreadCount > 0);
    }
    if (chatSearchQuery) {
        const cleanQuery = chatSearchQuery.replace(/\D/g, ''); 
        displaySidebar = displaySidebar.filter(c => c.phone.includes(cleanQuery));
    }

    const renderMediaPreview = (url, fallbackType = '') => {
        if (!url) { return <div style={{ background: '#eee', height: '120px', borderRadius: '4px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: '12px', fontWeight: 'bold' }}>{fallbackType} HEADER</div>; }
        const isVideo = url.match(/\.(mp4|mov|wmv|avi|webm)$/i);
        if (isVideo) { return <video src={url} style={{ width: '100%', borderRadius: '4px', marginBottom: '8px', background: '#000' }} controls autoPlay muted loop onError={(e) => e.target.style.display = 'none'} />; }
        return <img src={url} alt="Media Preview" style={{ width: '100%', borderRadius: '4px', marginBottom: '8px', objectFit: 'cover' }} onError={(e) => e.target.style.display = 'none'} />;
    };

    const filteredTemplates = templates.filter(t => t.template_name.toLowerCase().includes(templateSearchQuery.toLowerCase()));
    const filteredFaqs = faqList.filter(f => f.question.toLowerCase().includes(faqSearchQuery.toLowerCase()) || f.answer.toLowerCase().includes(faqSearchQuery.toLowerCase()));

    if (isAppLoading) return <div style={{ padding: '40px', textAlign: 'center', fontSize: '18px', color: '#666' }}>Loading FCOMIFY Standalone Engine...</div>;

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'system-ui' }}>
            <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>FCOMIFY Standalone CRM</h2>
                {hasLicense ? <span style={{ background: '#edfaee', color: '#00a32a', padding: '5px 10px', borderRadius: '4px', fontSize: '13px', fontWeight: 'bold' }}>✅ Licensed</span> : <span style={{ background: '#fcf0f1', color: '#d63638', padding: '5px 10px', borderRadius: '4px', fontSize: '13px', fontWeight: 'bold' }}>❌ Unlicensed</span>}
            </div>

            <div style={{ display: 'flex', gap: '8px', marginBottom: '25px', flexWrap: 'wrap' }}>
                <button onClick={() => setActiveTab('chat')} style={tabStyle(activeTab === 'chat')}>💬 Live Chat</button>
                <button onClick={() => setActiveTab('campaigns')} style={tabStyle(activeTab === 'campaigns')}>📢 Bulk Send</button>
                <button onClick={() => setActiveTab('schedule')} style={tabStyle(activeTab === 'schedule')}>🕒 Schedule Message</button>
                <button onClick={() => setActiveTab('logs')} style={tabStyle(activeTab === 'logs')}>📊 Delivery Logs</button>
                <button onClick={() => setActiveTab('phonebook')} style={tabStyle(activeTab === 'phonebook')}>📖 Phonebook</button>
                <button onClick={() => setActiveTab('leads')} style={tabStyle(activeTab === 'leads')}>🎯 Lead Management</button>
                <button onClick={() => setActiveTab('templates')} style={tabStyle(activeTab === 'templates')}>📄 Templates</button>
                <button onClick={() => setActiveTab('faq')} style={tabStyle(activeTab === 'faq')}>📚 FAQ</button>
                <button onClick={() => setActiveTab('support')} style={tabStyle(activeTab === 'support')}>🆘 Support</button>
                <button onClick={() => setActiveTab('settings')} style={tabStyle(activeTab === 'settings')}>⚙️ Settings</button>
            </div>

            {!hasLicense && activeTab !== 'settings' ? (
                <div style={{ background: '#fff', padding: '40px', border: '1px solid #d63638', borderRadius: '4px', textAlign: 'center' }}><h2 style={{ color: '#d63638' }}>License Verification Required</h2><p>Please enter a valid FCOMIFY License Key to unlock the CRM features.</p><button onClick={() => setActiveTab('settings')} style={{...btnStyle, fontSize: '16px', padding: '10px 20px'}}>Go to Settings</button></div>
            ) : (
                <div style={{ background: '#fff', padding: '20px', border: '1px solid #c3c4c7', borderRadius: '4px' }}>
                    
                    {/* ---------- CAMPAIGNS & SCHEDULE TAB ---------- */}
                    {(activeTab === 'campaigns' || activeTab === 'schedule') && (
                        <div style={{ display: 'flex', gap: '40px' }}>
                            <div style={{ flex: '2', maxWidth: '600px' }}>
                                <h3 style={{ marginTop: 0 }}>{activeTab === 'schedule' ? '🕒 Schedule a Message' : '🚀 Send Bulk Campaign'}</h3>
                                <form onSubmit={handleSendOrScheduleCampaign}>
                                    <div style={{ marginBottom: '20px', display: 'flex', gap: '15px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}><input type="radio" checked={campaignTargetType === 'group'} onChange={() => setCampaignTargetType('group')} style={{ marginRight: '5px' }} />Send to Group</label>
                                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}><input type="radio" checked={campaignTargetType === 'manual'} onChange={() => setCampaignTargetType('manual')} style={{ marginRight: '5px' }} />Manual Numbers</label>
                                    </div>
                                    
                                    {campaignTargetType === 'group' ? ( 
                                        <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Target Group</label><select value={campaignGroup} onChange={(e) => setCampaignGroup(e.target.value)} style={inputStyle} required><option value="" disabled>Select a Group...</option>{groups.map(g => <option key={g.id} value={g.id}>{g.group_name}</option>)}</select></div> 
                                    ) : ( 
                                        <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Manual Numbers (Comma Separated)</label><textarea value={campaignManualNumbers} onChange={(e) => setCampaignManualNumbers(e.target.value)} rows="3" style={inputStyle} placeholder="e.g. 8801700000001, 8801700000002" required></textarea></div> 
                                    )}
                                    
                                    <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Select Official Template</label><select value={campaignTemplate} onChange={(e) => { setCampaignTemplate(e.target.value); setCampaignMessage(''); }} style={inputStyle}><option value="">-- Send a standard text message instead --</option>{templates.map(t => <option key={t.id} value={t.template_name}>{t.template_name}</option>)}</select></div>
                                    
                                    <div style={{ marginBottom: '15px', padding: '15px', border: '1px solid #c8d8e8', borderRadius: '4px', background: '#f0f6fc' }}>
                                        <label style={{...labelStyle, color: '#2271b1'}}>📸 Attachment URL (Optional)</label>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <input type="url" value={campaignMediaUrl} onChange={(e) => setCampaignMediaUrl(e.target.value)} style={inputStyle} placeholder="https://..." />
                                            <button type="button" onClick={() => handleMediaPrompt(setCampaignMediaUrl)} style={{ ...btnStyle, background: '#f0ad4e', color: '#000', whiteSpace: 'nowrap' }}>🔗 Provide Link</button>
                                        </div>
                                    </div>

                                    {!campaignTemplate && <div style={{ marginBottom: '15px' }}><label style={labelStyle}>Standard Message</label><textarea value={campaignMessage} onChange={(e) => setCampaignMessage(e.target.value)} rows="5" style={inputStyle} placeholder="Write your message here..."></textarea></div>}
                                    
                                    {activeTab === 'schedule' && (
                                        <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #e1b400', borderRadius: '4px', background: '#fff8e5' }}>
                                            <label style={{...labelStyle, color: '#8a6d00'}}>🗓️ Schedule Date & Time</label>
                                            <input type="datetime-local" value={campaignScheduleTime} onChange={(e) => setCampaignScheduleTime(e.target.value)} style={inputStyle} required />
                                            <small style={{color: '#666', marginTop: '5px', display: 'block'}}>Your cron job must be configured to trigger the scheduler.</small>
                                        </div>
                                    )}

                                    <button type="submit" disabled={isSending} style={{ ...btnStyle, background: activeTab === 'schedule' ? '#d63638' : '#2271b1', padding: '12px 24px', fontSize: '16px' }}>{isSending ? 'Processing...' : (activeTab === 'schedule' ? '🗓️ Schedule Message' : '🚀 Blast Campaign')}</button>
                                    {campaignStatus && <div style={{ marginTop: '20px', padding: '12px', background: campaignStatus.type === 'success' ? '#edfaee' : '#fcf0f1', color: '#3c434a' }}><strong>{campaignStatus.type === 'success' ? '✅ Result:' : '❌ Error:'}</strong> {campaignStatus.text}</div>}
                                </form>
                            </div>
                            
                            <div style={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
                                <div style={{ width: '320px', height: 'fit-content', background: '#e5ddd5', borderRadius: '20px', padding: '20px 10px', border: '8px solid #333', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                                    <div style={{ background: '#fff', borderRadius: '8px', padding: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', position: 'relative' }}>
                                        {renderMediaPreview(campaignMediaUrl)}
                                        <div style={{ fontSize: '14px', whiteSpace: 'pre-wrap', color: '#111' }}>
                                            {campaignTemplate 
                                                ? (templates.find(t => t.template_name === campaignTemplate)?.template_content || 'Template missing content') 
                                                : (campaignMessage || 'Select a template or type a message...')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ---------- LEAD MANAGEMENT TAB ---------- */}
                    {activeTab === 'leads' && (
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                <h3 style={{ margin: 0 }}>🎯 Intelligent Lead Management</h3>
                                <button onClick={handleCreateGroupFromLeads} disabled={leads.length === 0} style={{ ...btnStyle, background: leads.length === 0 ? '#ccc' : '#00a32a' }}>
                                    ➕ Create Target Group from List ({leads.length})
                                </button>
                            </div>
                            
                            <div style={{ background: '#f0f6fc', padding: '15px', borderRadius: '4px', border: '1px solid #c8d8e8', marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <label style={{ fontWeight: 'bold', color: '#2271b1' }}>Filter Customers By Communication History:</label>
                                <select value={leadFilter} onChange={(e) => setLeadFilter(e.target.value)} style={{...inputStyle, width: '300px'}}>
                                    <option value="all">Show All Customers</option>
                                    <option value="never">Never sent a message</option>
                                    <option value="7_days">Last communication ~7 days ago</option>
                                    <option value="15_days">Last communication ~15 days ago</option>
                                    <option value="30_days">Last communication 30+ days ago</option>
                                </select>
                            </div>

                            <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
                                <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', fontSize: '14px' }}>
                                    <thead style={{ background: '#f6f7f7' }}><tr style={{ borderBottom: '2px solid #ccc' }}><th style={{ padding: '12px' }}>Name</th><th style={{ padding: '12px' }}>Phone Number</th><th style={{ padding: '12px' }}>Last Contact Date</th><th style={{ padding: '12px' }}>Action</th></tr></thead>
                                    <tbody>
                                        {isFetchingLeads ? (<tr><td colSpan="4" style={{ padding: '20px', textAlign: 'center' }}>Scanning logs...</td></tr>) : null}
                                        {!isFetchingLeads && leads.length === 0 && (<tr><td colSpan="4" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No leads match this filter.</td></tr>)}
                                        {!isFetchingLeads && leads.map(lead => (
                                            <tr key={lead.phone} style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '12px', fontWeight: 'bold' }}>{lead.name}</td>
                                                <td style={{ padding: '12px' }}>+{lead.phone}</td>
                                                <td style={{ padding: '12px', color: '#666' }}>
                                                    {lead.last_contact ? `${formatTime(lead.last_contact)} (${lead.days_ago} days ago)` : <span style={{ color: '#d63638', fontWeight: 'bold' }}>Never Contacted</span>}
                                                </td>
                                                <td style={{ padding: '12px' }}>
                                                    <button onClick={() => { setActiveTab('chat'); setSelectedPhone(lead.phone); }} style={{ background: 'none', border: '1px solid #2271b1', color: '#2271b1', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Open Chat 💬</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* ---------- LIVE CHAT TAB ---------- */}
                    {activeTab === 'chat' && (
                        <div style={{ display: 'flex', gap: '20px', height: '600px' }}>
                            <div style={{ width: '300px', borderRight: '1px solid #ddd', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ padding: '0 10px 10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ margin: 0 }}>Conversations</h3>
                                    <button onClick={fetchLogs} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px' }}>🔄</button>
                                </div>
                                <div style={{ padding: '10px 10px 10px 0' }}>
                                    <input 
                                        type="text" 
                                        placeholder="🔍 Search phone number..." 
                                        value={chatSearchQuery}
                                        onChange={(e) => setChatSearchQuery(e.target.value)}
                                        style={{ ...inputStyle, marginBottom: '10px' }}
                                    />
                                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={showUnreadOnly} onChange={(e) => setShowUnreadOnly(e.target.checked)} style={{ marginRight: '8px' }} />Filter Unread Only
                                    </label>
                                </div>
                                <div style={{ overflowY: 'auto', flex: 1, paddingRight: '10px' }}>
                                    {displaySidebar.length === 0 ? <p style={{ color: '#666', fontSize: '13px' }}>No conversations found.</p> : null}
                                    {displaySidebar.map(chat => (
                                        <div key={chat.phone} onClick={() => handleSelectChat(chat.phone)} style={{ padding: '12px', borderBottom: '1px solid #eee', cursor: 'pointer', background: selectedPhone === chat.phone ? '#eef4fa' : '#fff', borderRadius: '4px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                <strong style={{ color: '#2271b1' }}>+{chat.phone}</strong>
                                                {chat.unreadCount > 0 && <span style={{ background: '#d63638', color: '#fff', fontSize: '11px', padding: '2px 6px', borderRadius: '10px' }}>{chat.unreadCount} New</span>}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {chat.lastMsg.direction === 'outbound' ? 'You: ' : ''}{chat.lastMsg.message_body}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#999', marginTop: '4px', textAlign: 'right' }}>{formatTime(chat.lastMsg.timestamp)}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#efeae2', borderRadius: '8px', overflow: 'hidden' }}>
                                {selectedPhone ? (
                                    <>
                                        <div style={{ padding: '15px 20px', background: '#fff', borderBottom: '1px solid #ddd', display: 'flex', alignItems: 'center' }}>
                                            <h3 style={{ margin: 0 }}>Chat with +{selectedPhone}</h3>
                                        </div>
                                        
                                        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            {groupedLogs[selectedPhone]?.map((msg, i) => {
                                                const isInbound = msg.direction && msg.direction.toLowerCase() === 'inbound';
                                                return (
                                                    <div key={msg.id || i} style={{ display: 'flex', flexDirection: 'column', alignItems: isInbound ? 'flex-start' : 'flex-end' }}>
                                                        <div style={{ maxWidth: '70%', padding: '10px 14px', borderRadius: '8px', background: isInbound ? '#fff' : '#dcf8c6', color: '#111', boxShadow: '0 1px 1px rgba(0,0,0,0.1)', borderBottomLeftRadius: isInbound ? '0' : '8px', borderBottomRightRadius: isInbound ? '8px' : '0' }}>
                                                            {renderChatBubbleContent(msg.message_body)}
                                                        </div>
                                                        <small style={{ color: '#888', fontSize: '11px', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            {formatTime(msg.timestamp)} 
                                                            {!isInbound && (msg.status === 'success' || msg.status === 'SUCCESS' ? <span style={{color: '#4fc3f7', fontSize: '14px'}}>✓✓</span> : <span style={{color: '#d63638', fontSize: '12px'}}>❌</span>)}
                                                        </small>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        
                                        <div style={{ background: '#f0f0f0', padding: '10px 15px', position: 'relative' }}>
                                            {showEmojiPicker && (
                                                <div style={{ position: 'absolute', bottom: '100%', left: '15px', background: '#fff', border: '1px solid #ccc', borderRadius: '8px', padding: '10px', width: '320px', maxHeight: '250px', overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: '8px', zIndex: 10, boxShadow: '0 -4px 10px rgba(0,0,0,0.1)' }}>
                                                    {commonEmojis.map(emoji => ( <span key={emoji} onClick={() => { setChatReply(prev => prev + emoji); setShowEmojiPicker(false); }} style={{ fontSize: '24px', cursor: 'pointer', padding: '2px', transition: 'transform 0.1s' }} onMouseOver={(e) => e.target.style.transform = 'scale(1.2)'} onMouseOut={(e) => e.target.style.transform = 'scale(1)'}>{emoji}</span> ))}
                                                </div>
                                            )}

                                            {chatMediaUrl && (
                                                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px', background: '#fff', padding: '6px 12px', borderRadius: '20px', width: 'fit-content', border: '1px solid #ccc' }}>
                                                    <span style={{ fontSize: '12px', color: '#2271b1', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📎 {chatMediaUrl.split('/').pop()}</span>
                                                    <button type="button" onClick={() => setChatMediaUrl('')} style={{ background: 'none', border: 'none', color: '#d63638', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
                                                </div>
                                            )}

                                            <form onSubmit={handleSendReply} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <button type="button" onClick={() => setShowEmojiPicker(!showEmojiPicker)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: '#54656f', padding: '0 5px' }} title="Add Emoji">😀</button>
                                                <button type="button" onClick={() => { setShowEmojiPicker(false); handleMediaPrompt(setChatMediaUrl); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: '#54656f', padding: '0 5px', transform: 'rotate(45deg)' }} title="Attach Media">📎</button>
                                                <input type="text" value={chatReply} onChange={(e) => setChatReply(e.target.value)} onClick={() => setShowEmojiPicker(false)} placeholder={chatMediaUrl ? "Add a caption... (optional)" : "Type a message..."} style={{ flex: 1, padding: '12px 15px', border: 'none', borderRadius: '20px', outline: 'none', fontSize: '15px' }} />
                                                <button type="submit" disabled={!chatReply && !chatMediaUrl} style={{...btnStyle, borderRadius: '50%', width: '45px', height: '45px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: (!chatReply && !chatMediaUrl) ? 0.5 : 1}} title="Send"><span style={{transform: 'translateX(-2px)'}}>➤</span></button>
                                            </form>
                                        </div>
                                    </>
                                ) : (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#666', background: '#fff' }}>Select a conversation from the left to start chatting.</div>)}
                            </div>
                        </div>
                    )}

                    {/* ---------- LOGS TAB ---------- */}
                    {activeTab === 'logs' && (
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}><h3 style={{ margin: 0 }}>Delivery & Error Logs</h3><button onClick={fetchLogs} style={btnStyle}>🔄 Refresh Logs</button></div>
                            <div style={{ overflowX: 'auto', background: '#f9f9f9', padding: '15px', borderRadius: '4px', border: '1px solid #ddd', maxHeight: '600px', overflowY: 'auto' }}>
                                <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', fontSize: '13px' }}>
                                    <thead style={{ position: 'sticky', top: '-15px', background: '#f9f9f9', zIndex: 1 }}><tr style={{ borderBottom: '2px solid #ccc' }}><th style={{ padding: '8px' }}>Date / Time</th><th style={{ padding: '8px' }}>Type</th><th style={{ padding: '8px' }}>Phone</th><th style={{ padding: '8px' }}>Message Snippet</th><th style={{ padding: '8px' }}>Status / Error Reason</th></tr></thead>
                                    <tbody>
                                        {[...logs].reverse().map(log => (<tr key={log.id} style={{ borderBottom: '1px solid #eee' }}><td style={{ padding: '8px', whiteSpace: 'nowrap', color: '#666' }}>{formatTime(log.timestamp)}</td><td style={{ padding: '8px' }}><span style={{ padding: '3px 6px', borderRadius: '3px', background: log.direction === 'inbound' ? '#e1f5fe' : '#f0f0f1', color: log.direction === 'inbound' ? '#0277bd' : '#666', fontSize: '11px', fontWeight: 'bold' }}>{log.direction.toUpperCase()}</span></td><td style={{ padding: '8px', fontWeight: 'bold' }}>+{log.phone_number}</td><td style={{ padding: '8px', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{log.message_body}</td><td style={{ padding: '8px' }}>{String(log.status).toUpperCase() === 'SUCCESS' || log.status === 'received' ? (<span style={{ color: '#00a32a', fontWeight: 'bold' }}>✅ {log.status}</span>) : (<span style={{ color: '#d63638', fontWeight: '500' }}>❌ {log.status}</span>)}</td></tr>))}
                                        {logs.length === 0 && <tr><td colSpan="5" style={{ padding: '15px', textAlign: 'center', color: '#666' }}>No logs found. Try sending a campaign first!</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* ---------- PHONEBOOK TAB ---------- */}
                    {activeTab === 'phonebook' && (
                        <div style={{ display: 'flex', gap: '40px' }}>
                            <div style={{ flex: '1' }}>
                                <h3 style={{ marginTop: 0 }}>Create a Group</h3>
                                <form onSubmit={handleAddGroup} style={{ marginBottom: '30px', display: 'flex', gap: '10px' }}><input type="text" placeholder="e.g. VIP Customers" value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} required style={inputStyle} /><button type="submit" style={btnStyle}>Add Group</button></form>
                                <div style={{ padding: '20px', background: '#f0f6fc', borderRadius: '4px', border: '1px solid #c8d8e8' }}><h3 style={{ marginTop: 0 }}>Bulk Import CSV/TXT</h3><select value={importGroupId} onChange={(e) => setImportGroupId(e.target.value)} style={{...inputStyle, marginBottom: '10px'}} required><option value="">Select Destination Group...</option>{groups.map(g => <option key={g.id} value={g.id}>{g.group_name}</option>)}</select><input type="file" accept=".csv,.txt" onChange={handleFileUpload} style={{ marginBottom: '10px', display: 'block' }} />{importStatus && <p style={{ fontSize: '13px', fontWeight: 'bold', color: '#2271b1' }}>{importStatus}</p>}<button onClick={handleBulkImport} disabled={parsedContacts.length === 0} style={{ ...btnStyle, opacity: parsedContacts.length === 0 ? 0.5 : 1 }}>Start Import</button></div>
                            </div>
                            <div style={{ flex: '2', background: '#f6f7f7', padding: '20px', borderRadius: '4px' }}>
                                <h3 style={{ marginTop: 0 }}>Total Contacts</h3>
                                <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}><thead><tr style={{ borderBottom: '2px solid #ddd' }}><th>Name</th><th>Phone</th><th>Group</th></tr></thead><tbody>{contacts.map(c => <tr key={c.id} style={{ borderBottom: '1px solid #eee' }}><td>{c.name}</td><td>{c.phone}</td><td style={{ color: '#2271b1', fontWeight: 'bold' }}>{c.group_name || 'Unassigned'}</td></tr>)}</tbody></table>
                            </div>
                        </div>
                    )}

                    {/* ---------- TEMPLATES TAB ---------- */}
                    {activeTab === 'templates' && (
                        <div>
                            {!showBuilder ? (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                        <h3 style={{ margin: 0 }}>Approved Templates</h3>
                                        <div><button onClick={() => setShowBuilder(true)} style={{ ...btnStyle, background: '#00a32a', marginRight: '10px' }}>➕ Create New Template</button><button onClick={handleSyncTemplates} disabled={isSyncing} style={btnStyle}>{isSyncing ? '🔄 Syncing...' : '🔄 Sync Approved'}</button></div>
                                    </div>
                                    {syncStatus && <p style={{ color: '#2271b1', fontWeight: 'bold', marginBottom: '15px' }}>{syncStatus}</p>}
                                    <div style={{ marginBottom: '20px' }}><input type="text" placeholder="🔍 Search templates by name..." value={templateSearchQuery} onChange={(e) => setTemplateSearchQuery(e.target.value)} style={{...inputStyle, padding: '12px', fontSize: '15px', borderRadius: '8px', border: '1px solid #2271b1'}} /></div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                                        {filteredTemplates.map(t => ( <div key={t.id} style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '15px', background: '#fafafa' }}><h4 style={{ margin: '0 0 10px 0', color: '#2271b1' }}>{t.template_name}</h4><div style={{ background: '#e1f5fe', padding: '10px', borderRadius: '4px', fontSize: '13px', whiteSpace: 'pre-wrap' }}>{t.template_content}</div></div> ))}
                                    </div>
                                </>
                            ) : (
                                <div style={{ display: 'flex', gap: '40px' }}>
                                    <div style={{ flex: '2' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                            <h3 style={{ margin: 0 }}>Template Builder</h3>
                                            <button onClick={() => setShowBuilder(false)} style={{ background: 'none', border: 'none', color: '#2271b1', cursor: 'pointer', fontWeight: 'bold' }}>&larr; Back to Templates</button>
                                        </div>
                                        <form onSubmit={handleCreateTemplate}>
                                            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                                                <div style={{ flex: 1 }}>
                                                    <label style={labelStyle}>Template Name</label>
                                                    <input type="text" value={tplName} onChange={(e) => setTplName(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '_'))} placeholder="e.g. seasonal_sale" style={inputStyle} required />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <label style={labelStyle}>Category</label>
                                                    <select value={tplCategory} onChange={(e) => setTplCategory(e.target.value)} style={inputStyle}>
                                                        <option value="MARKETING">Marketing</option>
                                                        <option value="UTILITY">Utility</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #eee', borderRadius: '8px', background: '#fafafa' }}>
                                                <label style={labelStyle}>Header (Optional)</label>
                                                <select value={tplHeaderType} onChange={(e) => setTplHeaderType(e.target.value)} style={{ ...inputStyle, marginBottom: '10px' }}>
                                                    <option value="NONE">None</option>
                                                    <option value="TEXT">Text Title</option>
                                                    <option value="IMAGE">Image</option>
                                                    <option value="VIDEO">Video</option>
                                                </select>
                                                
                                                {tplHeaderType === 'TEXT' && (
                                                    <input type="text" value={tplHeaderText} onChange={(e) => setTplHeaderText(e.target.value)} placeholder="Enter title (Max 60 chars)" maxLength="60" style={inputStyle} />
                                                )}
                                                {(tplHeaderType === 'IMAGE' || tplHeaderType === 'VIDEO') && (
                                                    <div style={{ display: 'flex', gap: '10px' }}>
                                                        <input type="url" value={tplHeaderMediaUrl} onChange={(e) => setTplHeaderMediaUrl(e.target.value)} placeholder="https://..." style={inputStyle} required />
                                                        <button type="button" onClick={() => handleMediaPrompt(setTplHeaderMediaUrl)} style={{ ...btnStyle, background: '#f0ad4e', color: '#000', whiteSpace: 'nowrap' }}>🔗 Provide Link</button>
                                                    </div>
                                                )}
                                            </div>
                                            
                                            <div style={{ marginBottom: '20px' }}>
                                                <label style={labelStyle}>Body Text</label>
                                                <textarea value={tplBody} onChange={(e) => setTplBody(e.target.value)} rows="5" placeholder="Use {{1}}, {{2}} OR {{customer_name}} for variables." style={inputStyle} required></textarea>
                                            </div>
                                            
                                            <div style={{ marginBottom: '20px' }}>
                                                <label style={labelStyle}>Footer (Optional)</label>
                                                <input type="text" value={tplFooter} onChange={(e) => setTplFooter(e.target.value)} placeholder="e.g. Reply STOP to unsubscribe" maxLength="60" style={inputStyle} />
                                            </div>
                                            
                                            <div style={{ marginBottom: '20px' }}>
                                                <label style={labelStyle}>Buttons (Optional)</label>
                                                {tplButtons.map((btn, i) => (
                                                    <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                                        <input type="text" value={btn.text} onChange={(e) => { const newBtns = [...tplButtons]; newBtns[i].text = e.target.value; setTplButtons(newBtns); }} placeholder="Button text" style={inputStyle} />
                                                        <button type="button" onClick={() => setTplButtons(tplButtons.filter((_, idx) => idx !== i))} style={{ background: '#d63638', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', padding: '0 10px' }}>X</button>
                                                    </div>
                                                ))}
                                                {tplButtons.length < 3 && <button type="button" onClick={() => setTplButtons([...tplButtons, { type: 'QUICK_REPLY', text: 'New Button' }])} style={{ background: '#f0f0f1', border: '1px solid #ccc', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>+ Add Quick Reply</button>}
                                            </div>
                                            
                                            <button type="submit" style={{ ...btnStyle, padding: '12px 24px', fontSize: '16px', width: '100%' }}>Submit Template to Meta 🚀</button>
                                            {tplSubmitStatus && <p style={{ marginTop: '15px', fontWeight: 'bold' }}>{tplSubmitStatus}</p>}
                                        </form>
                                    </div>
                                    <div style={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
                                        <div style={{ width: '320px', height: 'fit-content', background: '#e5ddd5', borderRadius: '20px', padding: '20px 10px', border: '8px solid #333', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                                            <div style={{ background: '#fff', borderRadius: '8px', padding: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', position: 'relative' }}>
                                                {tplHeaderType === 'TEXT' && tplHeaderText && <div style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '8px' }}>{tplHeaderText}</div>}
                                                {(tplHeaderType === 'IMAGE' || tplHeaderType === 'VIDEO') && renderMediaPreview(tplHeaderMediaUrl, tplHeaderType)}
                                                <div style={{ fontSize: '14px', whiteSpace: 'pre-wrap', color: '#111' }}>{tplBody || 'Type your message body...'}</div>
                                                {tplFooter && <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>{tplFooter}</div>}
                                            </div>
                                            {tplButtons.length > 0 && (<div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '10px' }}>{tplButtons.map((btn, i) => <div key={i} style={{ background: '#fff', padding: '10px', textAlign: 'center', borderRadius: '8px', color: '#00a884', fontWeight: '500', fontSize: '14px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>{btn.text || 'Button'}</div>)}</div>)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ---------- FAQ TAB ---------- */}
                    {activeTab === 'faq' && (
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                            <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px' }}>📚 Frequently Asked Questions</h3>
                            <input 
                                type="text" 
                                placeholder="🔍 Search FAQs..." 
                                value={faqSearchQuery} 
                                onChange={(e) => setFaqSearchQuery(e.target.value)} 
                                style={{...inputStyle, padding: '12px', fontSize: '15px', borderRadius: '8px', border: '1px solid #2271b1', marginBottom: '20px'}} 
                            />
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                {filteredFaqs.map((faq, index) => (
                                    <div key={index} style={{ border: '1px solid #c8d8e8', borderRadius: '8px', overflow: 'hidden' }}>
                                        <div style={{ background: '#f0f6fc', padding: '15px', fontWeight: 'bold', color: '#2271b1', borderBottom: '1px solid #c8d8e8' }}>
                                            {faq.question}
                                        </div>
                                        <div style={{ padding: '15px', background: '#fff', color: '#3c434a', lineHeight: '1.5' }}>
                                            {faq.answer}
                                        </div>
                                    </div>
                                ))}
                                {filteredFaqs.length === 0 && <p style={{ textAlign: 'center', color: '#666' }}>No matching FAQs found.</p>}
                            </div>
                        </div>
                    )}

                    {/* ---------- SUPPORT TICKETS TAB ---------- */}
                    {activeTab === 'support' && (
                        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                                <h3 style={{ margin: 0 }}>🆘 FCOMIFY Support</h3>
                                {!selectedTicket && !showTicketForm && (
                                    <button onClick={() => setShowTicketForm(true)} style={{ ...btnStyle, background: '#00a32a' }}>➕ Create New Ticket</button>
                                )}
                                {(selectedTicket || showTicketForm) && (
                                    <button onClick={() => { setSelectedTicket(null); setShowTicketForm(false); }} style={{ background: 'none', border: 'none', color: '#2271b1', cursor: 'pointer', fontWeight: 'bold' }}>&larr; Back to Tickets</button>
                                )}
                            </div>

                            {showTicketForm ? (
                                <form onSubmit={handleSendSupportTicket} style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', maxWidth: '600px', margin: '0 auto' }}>
                                    <p style={{ color: '#666', marginBottom: '20px', marginTop: 0 }}>Fill out the form below and it will securely email the FCOMIFY engineering team.</p>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={labelStyle}>Subject</label>
                                        <input type="text" value={supportSubject} onChange={(e) => setSupportSubject(e.target.value)} placeholder="Brief description of the issue" style={inputStyle} required />
                                    </div>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={labelStyle}>Message Details</label>
                                        <textarea value={supportMessage} onChange={(e) => setSupportMessage(e.target.value)} rows="6" placeholder="Please provide as much detail as possible, including any error codes you see in the Logs tab." style={inputStyle} required></textarea>
                                    </div>
                                    <button type="submit" disabled={supportStatus?.type === 'loading'} style={{ ...btnStyle, background: '#00a32a', padding: '12px 24px', fontSize: '16px', width: '100%' }}>
                                        {supportStatus?.type === 'loading' ? 'Sending Ticket...' : '✉️ Submit Support Ticket'}
                                    </button>
                                    {supportStatus && supportStatus.type !== 'loading' && (
                                        <div style={{ marginTop: '15px', padding: '12px', background: supportStatus.type === 'success' ? '#edfaee' : '#fcf0f1', borderLeft: `4px solid ${supportStatus.type === 'success' ? '#00a32a' : '#d63638'}`, color: '#3c434a' }}>
                                            <strong>{supportStatus.type === 'success' ? '✅ Success:' : '❌ Error:'}</strong> {supportStatus.text}
                                        </div>
                                    )}
                                </form>
                            ) : selectedTicket ? (
                                <div style={{ background: '#f6f7f7', borderRadius: '8px', border: '1px solid #ddd', overflow: 'hidden' }}>
                                    <div style={{ padding: '15px 20px', background: '#fff', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h3 style={{ margin: 0 }}>Ticket #{selectedTicket.id}: {selectedTicket.subject}</h3>
                                        <span style={{ padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', background: selectedTicket.status === 'Responded' ? '#edfaee' : '#fff8e5', color: selectedTicket.status === 'Responded' ? '#00a32a' : '#8a6d00', border: `1px solid ${selectedTicket.status === 'Responded' ? '#c3e5c7' : '#e1b400'}` }}>
                                            {selectedTicket.status === 'Responded' ? '✅ Responded' : '⏳ Pending Reply'}
                                        </span>
                                    </div>
                                    
                                    <div style={{ padding: '20px', maxHeight: '400px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                        {JSON.parse(selectedTicket.chat_history).map((msg, index) => {
                                            const isYou = msg.sender === 'You';
                                            return (
                                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: isYou ? 'flex-end' : 'flex-start' }}>
                                                    <div style={{ maxWidth: '80%', padding: '12px 16px', borderRadius: '8px', background: isYou ? '#e1f5fe' : '#fff', border: '1px solid #ddd', color: '#111' }}>
                                                        <strong style={{ display: 'block', fontSize: '12px', color: isYou ? '#0277bd' : '#d63638', marginBottom: '5px' }}>{msg.sender}</strong>
                                                        <div style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>{msg.message}</div>
                                                    </div>
                                                    <small style={{ color: '#888', fontSize: '11px', marginTop: '4px' }}>{formatTime(msg.timestamp)}</small>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div style={{ background: '#fff', padding: '15px', borderTop: '1px solid #ddd' }}>
                                        <form onSubmit={handleSendTicketReply} style={{ display: 'flex', gap: '10px' }}>
                                            <textarea value={ticketReply} onChange={(e) => setTicketReply(e.target.value)} placeholder="Add additional context to this ticket..." rows="2" style={{ ...inputStyle, flex: 1, resize: 'none' }} required></textarea>
                                            <button type="submit" disabled={isReplying || !ticketReply} style={{ ...btnStyle, alignSelf: 'flex-end' }}>{isReplying ? 'Sending...' : 'Send Reply'}</button>
                                        </form>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '4px', border: '1px solid #ddd' }}>
                                    <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', fontSize: '14px' }}>
                                        <thead style={{ background: '#f6f7f7' }}>
                                            <tr style={{ borderBottom: '2px solid #ccc' }}>
                                                <th style={{ padding: '12px' }}>ID</th>
                                                <th style={{ padding: '12px' }}>Subject</th>
                                                <th style={{ padding: '12px' }}>Status</th>
                                                <th style={{ padding: '12px' }}>Last Updated</th>
                                                <th style={{ padding: '12px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {supportTickets.map(ticket => (
                                                <tr key={ticket.id} style={{ borderBottom: '1px solid #eee' }}>
                                                    <td style={{ padding: '12px', color: '#666' }}>#{ticket.id}</td>
                                                    <td style={{ padding: '12px', fontWeight: 'bold' }}>{ticket.subject}</td>
                                                    <td style={{ padding: '12px' }}>
                                                        <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold', background: ticket.status === 'Responded' ? '#edfaee' : '#fff8e5', color: ticket.status === 'Responded' ? '#00a32a' : '#8a6d00' }}>
                                                            {ticket.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: '12px', color: '#666' }}>{formatTime(ticket.updated_at)}</td>
                                                    <td style={{ padding: '12px' }}>
                                                        <button onClick={() => setSelectedTicket(ticket)} style={{ background: 'none', border: '1px solid #2271b1', color: '#2271b1', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>View Thread 💬</button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {supportTickets.length === 0 && (
                                                <tr><td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>You haven't opened any support tickets yet.</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ---------- SETTINGS TAB ---------- */}
                    {activeTab === 'settings' && (
                        <div style={{ maxWidth: '800px' }}>
                            <div style={{ padding: '20px', background: hasLicense ? '#edfaee' : '#fcf0f1', border: `1px solid ${hasLicense ? '#c8d8e8' : '#d63638'}`, borderRadius: '4px', marginBottom: '30px' }}>
                                <h3 style={{ marginTop: 0, color: hasLicense ? '#00a32a' : '#d63638' }}>FCOMIFY SaaS License</h3>
                                <p style={{ marginTop: 0 }}>Enter your official license key to unlock all CRM features.</p>
                                <input type="text" value={licenseKey} onChange={(e) => setLicenseKey(e.target.value)} placeholder="Enter your License Key..." style={{...inputStyle, marginBottom: '15px'}} />
                                <button onClick={handleSaveSettings} style={{...btnStyle, background: hasLicense ? '#00a32a' : '#2271b1'}}>{hasLicense ? 'Update Key' : 'Activate License'}</button>
                            </div>

                            <h3 style={{ marginTop: '40px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Meta Cloud API Credentials</h3>
                            <div style={{ padding: '20px', background: '#f0f6fc', border: '1px solid #c8d8e8', borderRadius: '4px', marginBottom: '30px' }}>
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={labelStyle}>Permanent Access Token</label>
                                    <input type="password" value={metaToken} onChange={(e) => setMetaToken(e.target.value)} style={inputStyle} />
                                </div>
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={labelStyle}>Phone Number ID</label>
                                    <input type="text" value={phoneId} onChange={(e) => setPhoneId(e.target.value)} style={inputStyle} />
                                </div>
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={labelStyle}>WhatsApp Business Account ID</label>
                                    <input type="text" value={businessId} onChange={(e) => setBusinessId(e.target.value)} style={inputStyle} />
                                </div>
                                <button onClick={handleSaveSettings} style={{...btnStyle, background: '#2271b1'}}>Save API Keys</button>
                            </div>

                            <h3 style={{ marginTop: '40px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Webhook & Notifications</h3>
                            <div style={{ padding: '20px', background: '#f6f7f7', border: '1px solid #c8d8e8', borderRadius: '4px', marginBottom: '30px' }}>
                                <p>Webhook URL: <code>https://yourdomain.com/api/router.php?route=webhook</code></p>
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={labelStyle}>Verify Token</label>
                                    <input type="text" value={webhookToken} onChange={(e) => setWebhookToken(e.target.value)} style={inputStyle} />
                                </div>
                                <label style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', marginBottom: '15px', cursor: 'pointer' }}>
                                    <input type="checkbox" checked={notifyEnable === '1'} onChange={(e) => setNotifyEnable(e.target.checked ? '1' : '0')} style={{ marginRight: '10px' }} />
                                    Enable Email Alerts for New Messages
                                </label>
                                {notifyEnable === '1' && (
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={labelStyle}>Admin Email Address</label>
                                        <input type="email" value={notifyEmail} onChange={(e) => setNotifyEmail(e.target.value)} style={inputStyle} />
                                    </div>
                                )}
                                <button onClick={handleSaveSettings} style={{...btnStyle, background: '#2271b1'}}>Save Webhook Settings</button>
                            </div>

                            <h3 style={{ marginTop: '30px' }}>Meta API Status</h3>
                            <div style={{ padding: '20px', background: '#f6f7f7', border: '1px solid #ccd0d4', borderRadius: '4px', textAlign: 'center', marginBottom: '30px' }}>
                                <button onClick={handleTestConnection} disabled={isTesting} style={{ ...btnStyle, padding: '12px 24px', fontSize: '16px' }}>{isTesting ? 'Pinging...' : '🔌 Test API Connection'}</button>
                                {testStatus && (<div style={{ marginTop: '20px', padding: '12px', borderRadius: '4px', textAlign: 'left', background: testStatus.type === 'success' ? '#edfaee' : '#fcf0f1', color: '#3c434a' }}><strong>{testStatus.type === 'success' ? '✅ Success:' : '❌ Failed:'}</strong> {testStatus.text}</div>)}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const labelStyle = { display: 'block', fontWeight: 'bold', marginBottom: '5px' };
const tabStyle = (isActive) => ({ padding: '10px 20px', cursor: 'pointer', border: 'none', borderRadius: '4px', fontWeight: '500', background: isActive ? '#2271b1' : '#f0f0f1', color: isActive ? '#fff' : '#3c434a' });
const inputStyle = { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%', boxSizing: 'border-box' };
const btnStyle = { background: '#2271b1', color: '#fff', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' };

export default FcomifyStandalone;